import React, { FC } from 'react';
import { RelatedServiceProps } from './components/types';
import { DiscountRelatedService } from './components/discount-related-service';
import { RelatedService } from './components';
import { getIsEnableServicesDiscount } from '../page-model';
import { useSelector } from 'react-redux';

export const RelatedServiceFactory: FC<RelatedServiceProps> = (props) => {
  const {
    service: { sales },
  } = props;
  const isEnableServicesDiscount = useSelector(getIsEnableServicesDiscount);
  return sales?.discountPercent && sales?.originalPrice && isEnableServicesDiscount ? (
    <DiscountRelatedService {...props} />
  ) : (
    <RelatedService {...props} />
  );
};
